<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" @keydown.esc="closeDialog" max-width="540px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Send Message</span>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear v-if="waiting" :indeterminate="true"/>
                    <v-text-field
                            v-model="title"
                            :rules="titleRules"
                            counter="35"
                            label="Message Title">
                    </v-text-field>
                    <v-container pt-3 pb-0 px-0>
                        <v-textarea
                                v-model="body"
                                :rules="bodyRules"
                                outlined
                                counter="140"
                                :label="`Send message to: ${orgName}`">
                        </v-textarea>
                    </v-container>
                </v-card-text>
                <v-card-actions class="mr-2">
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="send">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'send-message-dialog',
        data: function ()
        {
            return {
                dialogLocal: false,
                title: '',
                body: '',
                titleRules: [v => v.length <= 35 || 'Max 35 characters'],
                bodyRules: [v => v.length <= 140 || 'Max 140 characters']
            }
        },
        props:
        {
            dialog: Boolean(false),
            orgName: '',
            orgId: ''
        },
        computed:
        {
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        watch:
        {
            dialogLocal(val)
            {
                if (!val)
                {
                    this.$emit('dialog-close')
                }
            },
            dialog(val)
            {
                this.title = '';
                this.body = '';
                this.dialogLocal = val
            }
        },
        methods:
        {
            ...mapActions('sendMessage', ['SEND_MESSAGE']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            closeDialog()
            {
                this.$emit('dialog-close')
            },
            async send()
            {
                try
                {
                    this.HIDE_SNACKBAR();

                    this.title = this.title.trimEnd();
                    this.body = this.body.trimEnd();

                    if ('' === this.title || '' === this.body)
                    {
                        this.SHOW_SNACKBAR_ERROR('A title and body are needed before a message can be sent.');
                        return
                    }

                    this.WAITING(true);
                    const message =
                    {
                        message:
                        {
                            title: this.title,
                            body: this.body
                        }
                    };
                    if (this.orgId)
                    {
                        message['orgIds'] = [this.orgId]
                    }
                    await this.SEND_MESSAGE(message);
                    this.$emit('dialog-close')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message);
                }
                this.WAITING(false)
            }
        }
    };
</script>

<style scoped>
</style>